import {ReducerBuilder} from "co-redux-builders";
import FormModel from "../../../../model/Form";
import FormListCardActions from "./FormListCardAdminActions";
import TaskFormList from "../../../../ws/form/TaskFormList";
import {PagerBackendProps} from "../../../../components/Pager";
import TaskFormDelete from "../../../../ws/form/TaskFormDelete";

interface InitialState {
    loading: boolean,
    forms: FormModel[],
    error: string,
    pager: PagerBackendProps
}

const INITIAL_STATE: InitialState = {
    loading: false,
    forms: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)
    .onEvent(TaskFormDelete.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskFormDelete.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })

    .onEvent(TaskFormList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskFormList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskFormList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskFormList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            forms: payload.data,
            pager: payload.pager || oldState.pager,
        }
    })

    .onEvent(FormListCardActions.clearReducer, ((oldState, payload) => INITIAL_STATE))

    .build()